module.exports = __webpack_public_path__ + "static/media/thermometer-full.2022ff62.svg";